import React, { useCallback, useState } from 'react';
import { Button, DialogContent, DialogTitle, DialogActions, Dialog, Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';
import { useHistory } from 'react-router';
import AutocompleteSelect from '../atom/AutocompleteSelect';
import { apiActivityAutocomplete } from '../../autocomplete';

function ImportActivityModal({ showModal, MODAL_TYPE }) {
    const [importActivityId, setImportActivityId] = useState('');
    const { notifySuccess, notifyError } = useNotify();
    const history = useHistory();

    const importActivity = useCallback(
        importActivityId => {
            const req = doSwaggerCall('activities', 'importActivityById', {
                activityId: importActivityId
            });
            req.then(data => {
                notifySuccess('New activity imported!');
                showModal(MODAL_TYPE.NONE);
                history.push(`/admin/activity/update/${data.id}`);
            }).catch(err => {
                notifyError(err.response.body.message);
            });
        },
        [notifySuccess, showModal, MODAL_TYPE.NONE, history, notifyError]
    );

    return (
        <form>
            <Dialog
                aria-labelledby="import-activity-modal"
                open
                onClose={() => showModal(MODAL_TYPE.NONE)}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Import activity</DialogTitle>
                <DialogContent>
                    <form
                        id="import-activity-form"
                        onSubmit={ev => {
                            ev.preventDefault();
                            importActivity(importActivityId);
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <AutocompleteSelect
                                    initCall={apiActivityAutocomplete.init}
                                    autocompleteCall={apiActivityAutocomplete.search}
                                    value={importActivityId}
                                    setValue={newValue => {
                                        setImportActivityId(newValue);
                                    }}
                                >
                                    <TextField label="Activity" />
                                </AutocompleteSelect>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => showModal(MODAL_TYPE.NONE)}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!importActivityId}
                        type="submit"
                        form="import-activity-form"
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </form>
    );
}

export default ImportActivityModal;
